@if (invalidContext) {
  <div>
    Hmm... somehow you got here without the required parameters to accept an invite. Perhaps you received a bad link?
    Why don't you try again.
  </div>
} @else {
  @if (!!inviter) {
    <h3>You've been invited to {{ uiService.productName }}</h3>
    <div class="margin-top">
      <!-- Note, this message is synchronized with the same message seen in the emails sent by the
      server that gets a user to this page.  If you update it here, be sure to update the same
      message in authentication_service.py! -->
      {{ inviter }} has invited you to use {{ uiService.productName }} to manage business continuity for your AWS
      applications.
    </div>
    <div class="flex-center-column padding-top light-control-host">
      <button busy-button [busy]="acceptingInvite" class="arpio-button" (click)="acceptInviteClick()">
        ACCEPT INVITATION
      </button>
    </div>
  }
}
